
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 3.988a67.801 67.801 0 00-6.68-.334c-1.32 0-2.64.067-3.96.2L2 3.988M5.668 3.314l.147-.873C5.92 1.807 6 1.334 7.128 1.334h1.747c1.126 0 1.213.5 1.313 1.113l.147.867M12.567 6.094l-.433 6.713c-.074 1.047-.134 1.86-1.994 1.86H5.86c-1.86 0-1.92-.813-1.993-1.86l-.433-6.713M6.887 11h2.22M6.334 8.333h3.333","stroke":"#DE705C","stroke-width":"1.222","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    